import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **Premier Hotels & Resort**
 *
 * @exports bs_398
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
     * @memberOf module:bs_398
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            let lang = document.documentElement.lang;
            lang = lang === 'ua' ? 'uk' : lang;
            if (lang && ctx.langs.test(lang)) {
                resolve(lang);
                return;
            }
            reject('no_language');
        });
    };
    /**
        * @memberOf module:bs_398
        * @this thn.widgets.price
        * @see {@link Price#observe_dom}
        *
        * @param {object} ctx - The context object.
        */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('.container.rel');
        let priceUpdate;
        if (container && !priceUpdate) {
            priceUpdate = thn.debounce(() => thn.widgets.price.refresh(), 400);
            thn.observeDom(container, priceUpdate, {
                attributes: true,
                childList: true,
                subtree: true,
            });
            thn.pageUnload(function () {
                thn.stopObserveDom(container, priceUpdate);
                delete thn.priceUpdate;
            });
        }
    };
    /**
           * @memberOf module:bs_398
           * @this thn.widgets.price
           * @see {@link Price#set_data}
           *
           * @param {object} ctx - The context object.
           */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // Dates
        widgetData.dateBegin = document.querySelector('.comiseo-daterangepicker-check-in-text')?.textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        widgetData.dateEnd = document.querySelector('.comiseo-daterangepicker-check-out-text')?.textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        // Detailed room information
        const roomInfo = [...document.querySelectorAll('.container.rel .booking-count-cells .booking-count-cell')].map((el) => ({
            adults: thn.parseNumber(el.querySelector('a .select2-chosen')?.textContent) || 1,
            children: thn.parseNumber(el.querySelector('.booking-count-children span')?.textContent) || 0,
            childrenAges: [...el.querySelectorAll('.booking-count-ages .booking-count-ages-input')].map((age) => thn.parseNumber(age?.value)),
        }));
        let position = thn.parseNumber(document.querySelector('.hotels-results-rooms-nav .active')?.textContent);
        const positionRoom = position > 0 ? position -= 1 : 0;
        widgetData.roomsDispo = [roomInfo[positionRoom]];
        // Prices & Currency || No Rooms
        const prices = [...document.querySelectorAll('.price')].filter((el) => thn.isVisible(el)).map((el) => thn.parseNumber(el?.textContent));
        const currency = thn.parseCurrency(document.querySelector('.currency')?.textContent) || thn.parseCurrency(document.querySelector('#s2id_currency_select .select2-chosen')?.textContent);
        const noAvailability = !!document.querySelector('.section-title.smaller p')?.textContent?.match(/(no available rooms)|(немає вільних номерів)/);
        if (noAvailability) {
            widgetData.noRooms = true;
            return widgetData;
        }
        if (prices.length && currency) {
            widgetData.price = Math.min(...prices);
            widgetData.currency = currency;
            widgetData.set = true;
            widgetData.roomDetails = engine._roomDetailsParseData(roomInfo[positionRoom]?.adults, roomInfo[positionRoom]?.children);
        }
        return widgetData;
    };
    /**
        *
        * @memberOf module:bs_398
        *
        */
    engine._roomDetailsParseData = function roomDetailsParseData(adults, childrens) {
        const roomElArray = [...document.querySelectorAll('.room-tariff-cells.rooms-list div[class*=room-group]')];
        if (thn.empty(roomElArray)) {
            return {};
        }
        const roomsInfo = roomElArray
            .map((room) => {
            const roomName = room.querySelector('.title.room-tariff-more-2')?.textContent;
            const roomType = getRoomType(roomName);
            const rateName = room.querySelector('.icon.meal-plan.meal-plan-rate')?.textContent;
            const price = thn.parseNumber(room.querySelector('.price')?.textContent);
            const idRate = room.querySelector('.rate-id')?.value;
            const hasBreakfast = !!rateName?.match(/Breakfast|Сніданок/);
            const isRefundable = idRate === '53';
            return {
                id: '',
                name: roomName,
                adults: adults || 1,
                children: childrens || 0,
                type: roomType,
                prices: [{
                        id: '',
                        name: rateName,
                        totalNight: price,
                        breakfast: hasBreakfast,
                        refundable: isRefundable,
                    }],
            };
        }).filter(Boolean);
        return roomsInfo;
    };
    /**
           * @memberOf module:bs_398
           * @this thn.widgets.booking
           * @see {@link Booking#set_data}
           *
           * @param {object} ctx - The context object.
           */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        // bookingId
        const bookingId = document.querySelector('#booking-id-number')?.textContent;
        if (!bookingId) {
            widgetData.set = false;
            return widgetData;
        }
        widgetData.bookingId = bookingId;
        // Dates
        widgetData.dateBegin = document.querySelector('.comiseo-daterangepicker-check-in-text')?.textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        widgetData.dateEnd = document.querySelector('.comiseo-daterangepicker-check-out-text')?.textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        // Guests
        const guests = document.querySelector('.booking-count-click')?.textContent?.split(',');
        const adults = thn.parseNumber(guests[0]);
        const childrens = thn.parseNumber(guests[1]);
        widgetData.adults = adults;
        widgetData.children = childrens;
        widgetData.guests = adults + childrens;
        // Prices & currency
        widgetData.price = thn.parseNumber(document.querySelector('#booking-revenue')?.textContent);
        widgetData.currency = thn.parseCurrency(document.querySelector('#booking-revenue')?.textContent);
        return widgetData;
    };
    return engine;
}

export { factory };
